import Reveal from "@/components/Reveal";

const reasons = [
  { num: "01", title: "Quality First", text: "Attention to materials, workmanship and finishing." },
  { num: "02", title: "Detail Driven", text: "Every stage is planned and executed with precision." },
  { num: "03", title: "Transparent Process", text: "Clear communication and straightforward project coordination." },
  { num: "04", title: "Mumbai Based", text: "Serving Mumbai and surrounding areas." },
];

export default function WhyUs() {
  return (
    <section data-testid="why-us-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl mb-16">
          <p className="text-xs tracking-[0.25em] uppercase font-semibold text-zinc-500 mb-5">03 &middot; Why Choose Us</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-zinc-950">
            Why Saurabh Decor Creations?
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {reasons.map((r, i) => (
            <Reveal key={r.num} delay={i * 0.08}>
            <div data-testid={`why-us-${r.num}`} className="border-t border-zinc-950 pt-8">
              <span className="font-heading text-4xl font-light text-zinc-300">{r.num}</span>
              <h3 className="mt-5 font-heading text-xl font-medium text-zinc-950">{r.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-600">{r.text}</p>
            </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
